module.exports = __webpack_public_path__ + "media/src/images/graph_exp01-c14ad20353e7aa012e1bc72f178fede0.png";